export default "__VITE_ASSET__CxGtJJGL__"